var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.448,
    height: 18.476,
    viewBox: "0 0 19.448 18.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Download",
    "data-name": "Iconly/Bold/Download",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M8.975,13.817v3.9a.748.748,0,0,0,1.491.1l.007-.1v-3.9h4.648a4.4,4.4,0,0,0,4.322-4.259l0-.21v-4.9A4.4,4.4,0,0,0,15.333,0l-.2,0H4.318A4.386,4.386,0,0,0,0,4.258l0,.211v4.89a4.407,4.407,0,0,0,4.106,4.454l.2,0H8.975V7.591L7.42,9.2a.735.735,0,0,1-1.06,0,.812.812,0,0,1-.078-1l.078-.1,2.83-2.932a.726.726,0,0,1,.987-.069l.073.069L13.079,8.1a.794.794,0,0,1,0,1.095.734.734,0,0,1-.976.075L12.019,9.2,10.473,7.591v6.226Z",
    fill: "#142e38"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.aa5a7a7207e9a02b64644ae9ac456341.svg";
export { ForwardRef as ReactComponent };